module.exports = __webpack_public_path__ + "img/blackswan.f7cbe85d.png";